import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=52dd3e3e&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=52dd3e3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd3e3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dd3e3e')) {
      api.createRecord('52dd3e3e', component.options)
    } else {
      api.reload('52dd3e3e', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=52dd3e3e&scoped=true&", function () {
      api.rerender('52dd3e3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ash9XZ3QUqes/JS/comp/PopupDialog.vue"
export default component.exports